// extracted by mini-css-extract-plugin
module.exports = {"admin":"style_admin__2jCo2","dashboard":"style_dashboard__EZEDf","nav":"style_nav__26aP_","workspace":"style_workspace__IMB_R"};